import { CountryEnum } from "@vini-wine/core-enums";
import { VatTaxDto } from "@vini-wine/core-dtos";

export interface VatTaxModel {
  countryCode: CountryEnum;
  value: string;
}

export const createVatTaxDtoFromAdminVatTaxModel = (
  vatTax: VatTaxModel,
): VatTaxDto => {
  return {
    countryCode: vatTax.countryCode,
    value: vatTax.value,
  };
};
